import { useState } from 'react'

function useDelay(delay: number): (arg: any) => any {
	const [timeoutID, setTimeoutID] = useState<number>()

	function addCall(closure: (arg: any) => any) {
		if (timeoutID) {
			window.clearTimeout(timeoutID)
		}
		setTimeoutID(window.setTimeout(closure, delay))
	}

	return addCall
}

export { useDelay }
